import { NativeModules, Platform } from 'react-native';
import { getCookie } from "./cookie";
const RTL_LANG = ['ar', 'ur', 'pa', 'ps', 'sd'];
const SUPPORT_LANG = ['en', 'zh', 'pt', 'tr', 'ar', 'bn', 'es', 'id', 'th', 'ur', 'in'];
export function getRequest() {
  let url = decodeURIComponent(window.location.search);
  const theRequest = {};
  if (url.indexOf('?') !== -1) {
    url = url.substr(1);
  }
  if (url) {
    const strs = url.split('&');
    for (let i = 0; i < strs.length; i++) {
      var _strs$i, _strs$i$split, _strs$i2;
      const srtArry = (_strs$i = strs[i]) === null || _strs$i === void 0 ? void 0 : (_strs$i$split = (_strs$i2 = _strs$i).split) === null || _strs$i$split === void 0 ? void 0 : _strs$i$split.call(_strs$i2, '=');
      const y = srtArry.shift();
      theRequest[y] = decodeURIComponent(srtArry.join('='));
    }
  }
  return theRequest;
}
export function getQuery(param) {
  if (URLSearchParams) {
    const urlSearchParams = new URLSearchParams(window.location.search);
    return urlSearchParams.get(param);
  }
  const urlObject = getRequest();
  return urlObject[param];
}
export const getDeviceLanguage = () => {
  var _NativeModules$KSLang;
  /**
   * 1、native language 格式：en%3Bq%3D1%2C%20zh-Hans-CN%3Bq%3D0.9
   * 2、decodeURIComponent('en%3Bq%3D1%2C%20zh-Hans-CN%3Bq%3D0.9') => "en;q=1, zh-Hans-CN;q=0.9"
   * 3、"en;q=1, zh-Hans-CN;q=0.9".split() => ["en;q=1, zh-Hans-CN;q=0.9"]
   *
   */
  const getWebLanguage = () => {
    const language = (getQuery('language') || getQuery('langCode') ||
    // 兼容snackvideo流量参数
    navigator.language || getCookie('language') || 'en').toLowerCase();
    return language;
  };
  const deviceLanguage = Platform.OS === 'web' ? getWebLanguage() : (_NativeModules$KSLang = NativeModules.KSLanguage) === null || _NativeModules$KSLang === void 0 ? void 0 : _NativeModules$KSLang.getLanguage();
  return deviceLanguage;
};
export function formatLangCode(langCode) {
  var _currentLangCode$spli;
  let currentLangCode;

  // 如果当前国家不支持，走英语
  if (!(SUPPORT_LANG !== null && SUPPORT_LANG !== void 0 && SUPPORT_LANG.length)) {
    return {
      langCode: 'en'
    };
  }

  // 查找语言, 未匹配走兜底
  if (SUPPORT_LANG.includes(langCode)) {
    // 先查找语言列表里是否直接支持系统语言+地区
    currentLangCode = langCode;
  } else {
    var _langCode$split;
    const withOutCountry = (_langCode$split = langCode.split('-')) === null || _langCode$split === void 0 ? void 0 : _langCode$split[0];
    // 剔除地区，仅查找语言，如果也没有就走兜底
    const sameLang = SUPPORT_LANG.find(val => {
      return val.includes(withOutCountry);
    });
    currentLangCode = sameLang || SUPPORT_LANG[0];
  }
  return {
    langCode: (_currentLangCode$spli = currentLangCode.split('-')) === null || _currentLangCode$spli === void 0 ? void 0 : _currentLangCode$spli[0]
  };
}
export function getLanguage(lang) {
  if (lang) {
    const {
      langCode
    } = formatLangCode(lang);
    return langCode;
  } else {
    var _getDeviceLanguage, _getDeviceLanguage$to;
    const deviceLanguage = (_getDeviceLanguage = getDeviceLanguage()) === null || _getDeviceLanguage === void 0 ? void 0 : (_getDeviceLanguage$to = _getDeviceLanguage.toLowerCase) === null || _getDeviceLanguage$to === void 0 ? void 0 : _getDeviceLanguage$to.call(_getDeviceLanguage);
    const {
      langCode
    } = formatLangCode(deviceLanguage);
    return langCode;
  }
}